import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Column,Panel,Display,Card} from 'ktm-ui';
import CustomToolTip from "../../components/CustomToolTip";

interface IdsBenLimit {
    PolicyBenefit_Id:string;
    CreditCalcMethod:string;
    HasAccrual:boolean;
};

interface IdsPolicy {
    Id:string;
    NextBenYear_Id:string;
    TotalProducts:number;
    AccrualProducts:number;
    SoleProduct_Id:string;
};

export default KTMScreen({name:"enroll.ben-limit.add"}, class extends React.Component<{policy_id:string,bencat_id:string,benyear_id:string}> {

    data:{
        dsBenLimit:IdsBenLimit;
        dsPolicy:IdsPolicy;
    }

    // Store original data for comparison
    originalData: IdsBenLimit | null = null;

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsBenLimit";
        await KTMApi.start(screen,{
            "@policy_id":this.props.policy_id,
            "@bencat_id":this.props.bencat_id,
            "@benyear_id":this.props.benyear_id,
        });
        screen.title = "Add Benefit";

        // Store a copy of the original data
        this.originalData = { ...this.data.dsBenLimit };
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.main_tab)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Add Benefit"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} style="primary" label="Save"/>
            </Dialog.Footer>
        );
    }

    main_tab({field,draw,action}:RenderEvent){
        return (
            <Panel>
                <Column>
                    {draw(this.details)}
                </Column>
            </Panel>
        );
    }

    details({field,draw,action}:RenderEvent){
        const canScheduleCredits = this.data.dsPolicy.TotalProducts > 0
            && this.data.dsPolicy.AccrualProducts === this.data.dsPolicy.TotalProducts;
        return (
            <Card>
                <Display field={field("PolicyBenefit_Id")}/>
                <Display
                    required
                    field={field("CreditCalcMethod")}
                    toolTip={
                        <CustomToolTip
                            header="Credit Calculation Method"
                            bodyContent="Choose Flat until we can offer Spending Accounts based on % of Salary."
                        />
                    }
                />
                {canScheduleCredits ? (<Display field={field("HasAccrual")}/>) : (<></>)}
            </Card>
        );
    }

    getChangedFields(originalData, updatedData) {
        if (!originalData) return {};
  
        const changes = {};
        for (const key in updatedData) {
          if (updatedData[key] !== originalData[key]) {
            changes[key] = {
              oldValue:
                originalData[key] !== undefined ? originalData[key] : "N/A",
              newValue: updatedData[key] !== undefined ? updatedData[key] : "N/A",
            };
          }
        }
        return changes;
    }

    async submit({screen}:ActionEvent){
        // Track changes
        const changes = this.getChangedFields(
            this.originalData,
            this.data.dsBenLimit
        );

        const logDetails = Object.entries(changes)
            .map(([key, value]) => {
            const change = value as { oldValue: any; newValue: any };
            return `${key}: ${change.oldValue} → ${change.newValue}`;
            })
            .join(" | ");

        const policyLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            Note: logDetails,
            Action: "Policy Add Benefit",
            PolicyId: this.props.policy_id,
            }),
        };

        await KTMApi.action(screen,"submit",{
            "@policy_id":this.props.policy_id,
            "@dsBenLimit.PolicyBenefit_Id":this.data.dsBenLimit.PolicyBenefit_Id,
            "@dsBenLimit.CreditCalcMethod":this.data.dsBenLimit.CreditCalcMethod,
            "@dsBenLimit.HasAccrual":this.data.dsBenLimit.HasAccrual,
            "@bencat_id":this.props.bencat_id,
            "@benyear_id":this.props.benyear_id,
        }).then(() => {
            fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        });
        screen.close({"continue":true});
    }

});
